<template>
  <div class="text-center" style="border: 1px solid #eee;" v-show="menuId || noMenu">
    <!-- /.box-header -->
    <div v-show="menuId">
      <div class="box-body" v-show="!isAdd">
        <div class="col-xs-12">
          <div class="inline-block pull-left text-left">
            <!--<h4 v-if="storeName">-->
            <!--{{storeName}}-->
            <!--</h4>-->
            <!--<h5><span class="text-red">＊</span> 直接。</h5>-->
          </div>
        </div>
        <div class="col-xs-12 p-0">
          <div class="grid" style="width: 100%;">
            <div class="col-xs-12 col-lg-4 grid-item p-5" v-for="(c, index) in category">
              <div class="col-xs-12 card">
                <div class="col-xs-12 text-left m-t-10">
                  &nbsp;
                  <label class="bg-green label label-text-60-p" @click="choseAllProduct(c)">全選</label>&nbsp;
                  <label class="bg-red label label-text-60-p" @click="cancelAllProduct(c)">全取消</label>
                  &nbsp;
                </div>
                <div class="col-xs-12 m-b-5 text-left p-x-15">
                  <div class="text-right inline-block block-checkbox text-15" style="margin-right: 15px; margin-top: 55px">
                    <span class="text-dark-gray text-13" v-if="showWord">{{showWord}}</span>
                    <span class="text-dark-gray text-13" v-else>加入</span>
                    <!--<span class="text-dark-gray text-13" style="margin-left: 18px;">訂購</span>-->
                    <!--<span class="text-dark-gray text-13" style="margin-left: 18px; margin-right: 5px;">顯示</span>-->
                  </div>
                </div>
                <div class="col-xs-12 card-title text-left p-x-15">
                  <span class="pull-left">{{c.name}}</span>
                  <div class="text-right inline-block m-r-15 block-checkbox">
                  <span class="checkbox-addmenu">
                    <!--<input type="checkbox" v-model="c.is_disabled" :id="'c-' + c.category_id + '-is-add'" class="css-checkbox" @input="changeCategoryAdd(c)">-->
                    <label :for="'c-' + c.category_id + '-is-add'" class="css-label css-label-add"></label>
                  </span>
                  </div>
                </div>
                <div class="col-xs-12 text-left">
                  <ul class="nav p-x-15">
                    <li class="card-product" v-for="(p, index) in c.product_list">
                      <div class="">
                        {{p.name}} <small>{{p.remark}}</small>
                        <div class="text-right inline-block block-checkbox">
                        <span class="checkbox-addmenu">
                          <input type="checkbox" v-model="p.is_disabled" :id="menuClass + 'p-' + p.product_id + '-is-add'" class="css-checkbox"  @input="changeProductAdd(c, p)">
                          <label :for="menuClass + 'p-' + p.product_id + '-is-add'" class="css-label css-label-add"></label>
                          <!--<label :for="p.product_id + '-is-add'" class="css-label css-label-add" :disabled="c.is_disabled" :class="{'disabled': c.is_disabled}"></label>-->
                        </span>
                        </div>
                        <!--
                        <div class="" v-for="(combine, index) in p.combine_list">
                          <span class="text-15 text-light-gray">
                            <i class="fa fa-caret-right" aria-hidden="true"></i>&nbsp;&nbsp;{{combine.name}} <small>{{combine.remark}}</small>
                          </span>
                          <div class="text-right inline-block block-checkbox">
                            <span class="checkbox-addmenu">
                              <input type="checkbox" v-model="combine.is_disabled" :id="'com-' + combine.combine_id + '-is-add'" class="css-checkbox"  @input="changeCombineAdd(c, p, combine)">
                              <label :for="'com-' + combine.combine_id + '-is-add'" class="css-label css-label-add"></label>
                            </span>
                          </div>
                        </div>
                        -->
                      </div>
                    </li>
                    <li class="card-product" v-for="(pa, index) in c.package_list">
                      <div class="">
                        {{pa.name}} <small>{{pa.remark}}</small>
                        <div class="text-right inline-block block-checkbox">
                        <span class="checkbox-addmenu">
                          <input type="checkbox" v-model="pa.is_disabled" :id="menuClass + pa.package_id + '-is-add'" class="css-checkbox" @input="changeProductAdd(c, pa)">
                          <label :for="menuClass + pa.package_id + '-is-add'" class="css-label css-label-add"></label>
                        </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
        <div class="col-xs-12 p-10" v-if="!$route.params.store_id">
          <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
            <hr>
            <div class="text-left">
              <h5>參與停賣店家
              </h5>
              <muti-select-two :setting="addStoresSetting"></muti-select-two>
            </div>
          </div>
        </div>
        -->
      </div>
      <div class="text-center">
        <button class="btn btn-success w-100-p text-w-600" v-if="isAdd" @click="isAdd = !isAdd">
          再次選擇
        </button>
        <button class="btn btn-primary w-100-p text-w-600" v-else @click="addProduct">
          確認
        </button>
      </div>
    </div>
    <div v-if="noMenu">
      <br>
      無菜單
      <br>
      <br>
    </div>
    <!-- 1 = add, 2 = edit, 3 = info -->
    <!--<combine-modal modalId="crCombineModal" :state="1" :productId="current.productId" :productName="current.productName"/>-->
    <!--<combine-modal modalId="infoCombineModal" :state="3" :productId="current.productId" :productName="current.productName"/>-->
    <!--<category-modal modalId="infoCategoryModal" :state="3" :categoryId="current.category"/>-->
    <!--<product-modal modalId="crProductModal" :state="1" :categoryId="current.categoryId" :categoryName="current.categoryName"/>-->
    <!--<product-modal modalId="infoProductModal" :state="3" :categoryId="current.product" :categoryName="current.categoryName"/>-->
  </div>
</template>
<script>
import $ from 'jquery'
import Masonry from 'masonry-layout'
export default {
  props: {
    'info': {
      type: Object
    },
    menuId: {
      type: [Number, String]
    },
    showWord: {
      type: String
    },
    className: String
  },
  data () {
    return {
      first: true,
      noMenu: false,
      isAdd: false,
      brandId: this.$route.params.brand_id,
      current: {
        productName: '',
        productId: 0
      },
      count: 20,
      brandName: '',
      brandType: '',
      amount: {
        adjust: 1,
        option: 1,
        product: 1,
        category: 1,
        resource: 1,
        others: 1
      },
      adjustNumList: [],
      adjust: [],
      option: [],
      cateNumList: [],
      category: [],
      product: [],
      prodNumList: {},
      all: {
        category: [],
        product: [],
        adjust: [],
        option: [],
        combination: []
      },
      menuInfo: {},
      menuList: '',
      // if created checkbox all true, if not all false
      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      currentMenuJson: '',
      schema: {
        category: {},
        product: {},
        block: {},
        adjust: {},
        option: {},
        combine: {}
      },
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      disTableList: []
    }
  },
  methods: {
    init () {
      this.getMenuInfo()
      // this.getMenuResource()
      // this.getMenuContainer()
    },
    isActive (index) {
      if (index === 1) return true
      else return false
    },
    showMenu () {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
      /*
      if ($('.option-grid') && $('.option-grid-item')) {
        var n = new Masonry('.option-grid', {
          itemSelector: '.option-grid-item',
          columnWidth: '.option-grid-item'
        })
        n.reloadItems()
        n.layout()
      }
      */
    },
    getProduct (index) {
      return this.product[index]
    },
    gotoFrom () {
      if (this.menuId) this.$router.push('/upMenu/' + this.brandId + '/' + this.menuId)
      else this.$router.push('/crOption')
    },
    gotoNext () {
      // this.joinMenu()
      if (!this.addStoresSetting.choose.length && !this.$route.params.store_id) {
        this.$notify({
          title: '錯誤',
          text: '未選擇停賣店家',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else this.disProductList()
      // this.$router.push('/crJoinMenu')
    },
    setChoose () {
      var self = this
      var array = []
      if (self.$route.name.indexOf('up') > -1) {
        self.marketing.attend_stores.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            var curStore = store.store_id
            array.push(curStore)
          })
        })
        self.addStoresSetting.choose = array
      }
    },
    getMenuInfo () {
      var self = this
      var url = '/onlineMenu/' + this.menuId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.json_menu) {
            self.currentMenuJson = response.data.json_menu
            // 設定可設定店家
            var sList = response.data.store_list
            for (let i = 0; i < sList.length; i++) {
              let obj = {label: sList[i].name, value: sList[i].id}
              self.addStoresSetting.options.push(obj)
            }
            self.setSelectAndMenu()
            if (self.$route.params.store_id) self.getDisItemList()
          }
        }
      })
    },
    setSelectAndMenu () {
      var self = this
      this.currentMenuJson = JSON.parse(this.currentMenuJson)
      this.schema.category = this.currentMenuJson.category_list_json.schema
      this.schema.product = this.currentMenuJson.product_list_json.schema
      var cSchema = this.schema.category
      var pSchema = this.schema.product
      var category = this.currentMenuJson.category_list_json.data
      this.product = this.currentMenuJson.product_list_json.data
      // sort
      var menu = []
      var newMenu = []
      for (var key in category) {
        menu.push(category[key])
      }
      menu.forEach(function (category) {
        let obj = {
          category_id: category[cSchema.product_id],
          name: category[cSchema.name],
          sort: category[cSchema.sort],
          is_disabled: self.created,
          pList: category[cSchema.product_list],
          product_list: [],
          package_list: []
        }
        category[cSchema.product_list].forEach(function (pId) {
          let prod = self.getProduct(pId)
          let pObj = {
            product_id: prod[pSchema.product_id],
            vendor_custom_id: prod[pSchema.vendor_custom_id],
            name: prod[pSchema.name],
            sort: prod[pSchema.sort],
            is_disabled: self.created,
            product_type: prod[pSchema.type]
          }
          let paObj = {
            package_id: prod[pSchema.product_id],
            vendor_custom_id: prod[pSchema.vendor_custom_id],
            name: prod[pSchema.name],
            sort: prod[pSchema.sort],
            is_disabled: self.created,
            product_type: prod[pSchema.type]
          }
          if (prod[pSchema.type] === 1) obj.product_list.push(pObj)
          else if (prod[pSchema.type] === 3) obj.package_list.push(paObj)
        })
        newMenu.push(obj)
      })
      newMenu.sort(function (a, b) {
        return a.sort - b.sort
      })
      this.category = newMenu
    },
    addProduct () {
      var productInfo = []
      var caList = this.category
      for (var c = 0; c < caList.length; c++) {
        // if (caList[c].is_disabled) data.setting.category_list.disable.push(caList[c].category_id)
        // else data.setting.category_list.enable.push(caList[c].category_id)
        // product
        var pList = caList[c].product_list
        for (var p = 0; p < pList.length; p++) {
          let pOption = {
            product_type: pList[p].product_type,
            amount_unit: 1,
            vendor_custom_id: '',
            product_name: pList[p].name,
            discount: ''
          }
          if (pList[p].vendor_custom_id) {
            pOption.vendor_custom_id = pList[p].vendor_custom_id // 有vendor_id即帶入料號
            if (pList[p].is_disabled) productInfo.push(pOption)
          } else if (pList[p].is_disabled) {
            this.$notify({
              title: '訊息',
              text: '加入商品失敗，' + pList[p].name + '無商品料號',
              duration: 3000,
              type: 'danger',
              width: 400
            })
          }
        }
        // package
        var paList = caList[c].package_list
        for (var pa = 0; pa < paList.length; pa++) {
          let paOption = {
            product_type: paList[pa].product_type,
            amount_unit: 1,
            vendor_custom_id: '',
            product_name: paList[pa].name,
            discount: ''
          }
          if (paList[pa].vendor_custom_id) {
            paOption.vendor_custom_id = paList[pa].vendor_custom_id // 有vendor_id即帶入料號
            if (paList[pa].is_disabled) productInfo.push(paOption)
          } else if (paList[pa].is_disabled) {
            this.$notify({
              title: '訊息',
              text: '加入商品失敗，' + paList[pa].name + '無商品料號',
              duration: 3000,
              type: 'danger',
              width: 400
            })
          }
        }
      }
      try {
        this.$emit('addProdToList', productInfo)
        // 清空選鑿
        this.isAdd = true
        this.clearChoose()
      } catch (e) {
        this.$notify({
          title: '訊息',
          text: '加入商品失敗',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        this.isAdd = false
      }
    },
    clearChoose () {
      var caList = this.category
      for (var c = 0; c < caList.length; c++) {
        // product
        var pList = caList[c].product_list
        for (var p = 0; p < pList.length; p++) {
          pList[p].is_disabled = this.created
        }
        // package
        var paList = caList[c].package_list
        for (var pa = 0; pa < paList.length; pa++) {
          paList[pa].is_disabled = this.created
        }
      }
    },
    disProductList () {
      var self = this
      var data = {
        store_list: [],
        setting: {
          product_list: {
            enable: [],
            disable: []
          },
          package_list: {
            enable: [],
            disable: []
          },
          category_list: {
            enable: [],
            disable: []
          }
        }
      }
      if (this.addStoresSetting.choose.length) data.store_list = this.addStoresSetting.choose
      else if (this.$route.params.store_id) data.store_list = [this.$route.params.store_id]
      var caList = this.category
      for (var c = 0; c < caList.length; c++) {
        if (caList[c].is_disabled) data.setting.category_list.disable.push(caList[c].category_id)
        else data.setting.category_list.enable.push(caList[c].category_id)
        // product
        var pList = caList[c].product_list
        for (var p = 0; p < pList.length; p++) {
          if (pList[p].is_disabled) data.setting.product_list.disable.push(pList[p].product_id)
          else data.setting.product_list.enable.push(pList[p].product_id)
        }
        // package
        var paList = caList[c].package_list
        for (var pa = 0; pa < paList.length; pa++) {
          if (paList[pa].is_disabled) data.setting.package_list.disable.push(paList[pa].package_id)
          else data.setting.package_list.enable.push(paList[pa].package_id)
        }
      }
      var url = '/onlineMenu/' + this.menuId + '/productListStatus'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          // self.$router.push('/disItemTable')
          self.$notify({
            title: '訊息',
            text: '成功更新停賣資訊',
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    getDisItemList () {
      this.disTableList = []
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/disableItemList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.disTableList = response.data.item_list
          var disCategory = self.disTableList.category
          disCategory.forEach(function (c) {
            c.id_list.forEach(function (cId) {
              self.category.find(function (category) {
                if (category.category_id === cId) category.is_disabled = true
              })
            })
          })
          var disProd = self.disTableList.product
          disProd.forEach(function (p) {
            p.id_list.forEach(function (pId) {
              self.category.forEach(function (cc) {
                cc.product_list.find(function (prod) {
                  if (prod.product_id === pId) prod.is_disabled = true
                })
                // 暫時沒有package
                /*
                cc.package_list.find(function (pack) {
                  if (pack.package_id === pId) pack.is_disabled = true
                })
                */
              })
            })
          })
        }
      })
    },
    choseAllProduct (category) {
      this.category.filter(function (elem, index, obj) {
        if (elem.category_id === category.category_id) {
          elem.is_disabled = true
          if (elem.product_list.length) {
            for (var i = 0; i < elem.product_list.length; i++) {
              var product = elem.product_list[i]
              // product['is_enable'] = true
              // product['is_visible'] = true
              product['is_disabled'] = true
            }
          }
          if (elem.package_list.length) {
            for (var j = 0; j < elem.package_list.length; j++) {
              var pa = elem.package_list[j]
              // product['is_enable'] = true
              // product['is_visible'] = true
              pa['is_disabled'] = true
            }
          }
        }
      })
    },
    cancelAllProduct (category) {
      this.category.filter(function (elem, index, obj) {
        if (elem.category_id === category.category_id) {
          elem.is_disabled = false
          if (elem.product_list.length) {
            for (var i = 0; i < elem.product_list.length; i++) {
              var product = elem.product_list[i]
              product['is_disabled'] = false
            }
          }
          if (elem.package_list.length) {
            for (var j = 0; j < elem.package_list.length; j++) {
              var pa = elem.package_list[j]
              pa['is_disabled'] = false
            }
          }
        }
      })
    },
    changeCategoryAdd (category) {
      category.is_disabled = !category.is_disabled
      category.product_list.forEach(function (product) {
        product['is_disabled'] = category.is_disabled
        if (product.combine_list) {
          product.combine_list.forEach(function (combine) {
            combine['is_disabled'] = category.is_disabled
          })
        }
      })
      if (category.package_list) {
        category.package_list.forEach(function (pa) {
          pa['is_disabled'] = category.is_disabled
        })
      }
    },
    changeProductAdd (category, product) {
      product.is_disabled = !product.is_disabled
      if (product.combine_list) {
        for (var j = 0; j < product.combine_list.length; j++) {
          var combine = product.combine_list[j]
          combine['is_disabled'] = product.is_disabled
        }
      }
      // console.log(product.is_disabled)
      if (!product.is_disabled) {
        category.is_disabled = product.is_disabled
      }
    }
  },
  mounted () {
    this.showMenu()
  },
  updated () {
    this.showMenu()
    // if ($('body').hasClass('pace-running') > 0) this.getTimes = this.getTimes + 1
  },
  computed: {
    menuClass () {
      if (this.className) return this.className + '-'
      return ''
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    storeName () {
      var sId = parseInt(this.$route.params.store_id, 10)
      if (sId) {
        var sName = this.addStoresSetting.options.find(function (o) { return sId === o.value })
        if (sName) return sName.label + '菜單'
      }
      return ''
    }
  },
  watch: {
    menuId () {
      // console.log('menuId', this.menuId)
      if (this.menuId) {
        this.init()
        if (this.$route.name.indexOf('up') === -1 || !this.first) this.isAdd = false
        else this.isAdd = true
        this.noMenu = false
      } else {
        this.noMenu = true
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  .label-text-60-p
    font-size: 60% !important
  .m-t-10
    margin-top: 10px !important
  .m-b-5
    margin-bottom: 5px !important
  .m-r-5
    margin-right: 5px !important
  .m-r-20
    margin-right: 20px !important
  .m-r-15
    margin-right: 15px !important
  .block-checkbox
    right: 0px
    position: absolute
    top: 3px
  .card-title .block-checkbox
    top: 8px
  .checkbox-visible, .checkbox-enable
    margin-left: 20px
  .text-dark-gray
    color: #333 !important
  .text-light-gray
    color: #666 !important
  .text-13
    font-size: 13px !important
  .btn-option-show
    background: #ffffff
    border: 1px solid $default-color
    min-width: 100px
    font-size: 15px
    border-radius: 5px
    cursor: auto
  input[type="checkbox"]
    margin-left: 0
    padding: 0
  input[type=checkbox].css-checkbox
    position: absolute
    overflow: hidden
    clip: rect(0 0 0 0)
    height: 1px
    width: 1px
    margin: -1px
    padding: 0px
    border: 0
  input[type=checkbox].css-checkbox+label.css-label
    padding-left: 22px
    height: 16px
    width: 16px
    display: inline-block
    line-height: 15px
    background-repeat: no-repeat
    background-position: 0 0
    font-size: 13px
    vertical-align: middle
    cursor: pointer
    opacity: 1
  input[type=checkbox].css-checkbox+label.css-label:hover
    opacity: 0.5
  input[type=checkbox].css-checkbox:checked+label.css-label
    background-position: 0 -17px
  .css-label:not(.css-label-add)
    background-image: url(/static/img/checkbox.png)
    background-size: 16px
  .css-label.css-label-add
    background-image: url(/static/img/checkbox-add.png)
    background-size: 16px
  input[type=checkbox].css-checkbox+label.css-label.disabled:hover
    opacity: 1
</style>



// WEBPACK FOOTER //
// MenuDiscountTemp.vue?253ef102